export default "__VITE_ASSET__Dl4Glbyh__"